import styled from 'styled-components';
export const Wrapper = styled.div`
  z-index: 10;
  background-color: ${props => props.color};
  &::before {
    border-color: ${props => props.color};
  }
`;